export default __webpack_public_path__ + "/dist/images/travel-icon.14905226b8280052bb9e9c80ae110214.svg";